import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PRIZES = [
    { label: "1 Mois Offert", color: "#f87171" },
    { label: "- 5%", color: "#fbbf24" },
    { label: "Logo Offert", color: "#34d399" },
    { label: "Formation SEO", color: "#60a5fa" },
    { label: "Carte de Visite", color: "#a78bfa" },
    { label: "Rien... Rejouez !", color: "#94a3b8" },
];

export default function CommercialWheelPage() {
    const navigate = useNavigate();
    const [spinning, setSpinning] = useState(false);
    const [result, setResult] = useState(null);
    const [rotation, setRotation] = useState(0);

    const spin = () => {
        if (spinning || result) return;

        setSpinning(true);
        const spins = 5 + Math.random() * 5; // Entre 5 et 10 tours
        const finalAngle = spins * 360 + Math.floor(Math.random() * 360);

        setRotation(finalAngle);

        // Calculate result based on angle
        // Simplified: Random result for logic, visual is just for show in this basic version
        // In a real physics engine, we'd map the angle. Here we cheat slightly for UX.
        setTimeout(() => {
            setSpinning(false);
            const won = PRIZES[Math.floor(Math.random() * (PRIZES.length - 1))]; // Avoid losing for commercial reasons ;)
            setResult(won);
            // Confetti or sound could go here
        }, 5000); // 5s spin duration
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif' }}>

            <h1 style={{ marginBottom: 40, fontSize: '2.5rem', fontWeight: 800 }}>🎁 La Roue des Cadeaux</h1>

            <div style={{ position: 'relative', width: 400, height: 400 }}>
                {/* Tick */}
                <div style={{ position: 'absolute', top: -20, left: '50%', transform: 'translateX(-50%)', zIndex: 10, fontSize: '3rem' }}>🔻</div>

                {/* Wheel */}
                <div style={{
                    width: '100%', height: '100%', borderRadius: '50%', border: '10px solid white',
                    position: 'relative', overflow: 'hidden', transition: 'transform 5s cubic-bezier(0.25, 0.1, 0.25, 1)',
                    transform: `rotate(${rotation}deg)`,
                    background: `conic-gradient(
                        ${PRIZES[0].color} 0% 16.6%, 
                        ${PRIZES[1].color} 16.6% 33.3%, 
                        ${PRIZES[2].color} 33.3% 50%, 
                        ${PRIZES[3].color} 50% 66.6%, 
                        ${PRIZES[4].color} 66.6% 83.3%, 
                        ${PRIZES[5].color} 83.3% 100%
                    )`
                }}>
                    {/* Inner styling lines if needed */}
                </div>
            </div>

            <div style={{ marginTop: 50, height: 100, textAlign: 'center' }}>
                {result ? (
                    <div className="animate-pop">
                        <div style={{ fontSize: '1.5rem', opacity: 0.8 }}>Vous avez gagné :</div>
                        <div style={{ fontSize: '3rem', fontWeight: 900, color: result.color, textShadow: '0 0 20px rgba(255,255,255,0.2)' }}>{result.label} !</div>
                        <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 20, padding: '10px 30px', borderRadius: 50, border: 'none', background: 'white', color: 'black', fontWeight: 700, cursor: 'pointer' }}>Super !</button>
                    </div>
                ) : (
                    <button
                        onClick={spin} disabled={spinning}
                        style={{
                            padding: '20px 60px', borderRadius: 50, border: 'none',
                            background: spinning ? '#cbd5e1' : 'linear-gradient(to right, #ec4899, #8b5cf6)',
                            color: 'white', fontSize: '1.5rem', fontWeight: 800, cursor: spinning ? 'default' : 'pointer',
                            transform: spinning ? 'scale(0.95)' : 'scale(1)', transition: 'all 0.2s',
                            boxShadow: '0 10px 30px rgba(236, 72, 153, 0.4)'
                        }}
                    >
                        {spinning ? 'Suspense...' : 'LANCER !'}
                    </button>
                )}
            </div>

            {/* Back */}
            {!spinning && !result && (
                <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Annuler</button>
            )}

            <style>{`.animate-pop { animation: popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275); } @keyframes popIn { from { transform: scale(0.5); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>
        </div>
    );
}
